import { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";

import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Component_Products from "../components/Component_Products";

/* ================= PRODUCTS ================= */
export const PRODUCT_CARDS = [
  { title: "Cotton Round Neck T-Shirt", slug:"cotton-round-neck-t-shirt", gsm: 180, images:["/tshirts/rnw2.png","/tshirts/rnw5.png"] },
  { title: "Oversized Round Neck T-Shirt", slug:"oversized-round-neck-t-shirt", gsm: 240, images:["/tshirts/ob2.png","/tshirts/ob6.png"] },
  { title: "Dryfit Round Neck T-Shirt", slug:"dryfit-round-neck-t-shirt", gsm: 170, images:["/tshirts/rnb2.png","/tshirts/rnb5.png"] },
  { title: "Micropolyester Collar T-Shirt", slug:"micropolyester-collar-t-shirt", gsm: 220, images:["/polo/pbl2.png","/polo/pbl5.png"] },
  { title: "Micropolyester Collar T-Shirt with Press Buttons", slug:"micropolyester-collar-t-shirt-press-buttons", gsm: 220, images:["/polo/wc1.png","/polo/wc5.png"] },
  { title: "Cotton Collar T-Shirt", slug:"cotton-collar-t-shirt", gsm: 260, images:["/polo/pg2.png","/polo/pg5.png"] },
  { title: "Cotton Collar T-Shirt with Tipping", slug:"cotton-collar-t-shirt-with-tipping", gsm: 260, images:["/polo/pc2.png","/polo/pc5.png"] },
  { title: "Dryfit Collar T-Shirt", slug:"dryfit-collar-t-shirt", gsm: 200, images:["/polo/oc3.png","/polo/oc5.png"] },
  { title: "Dryfit Collar T-Shirt with Tipping", slug:"dryfit-collar-t-shirt-with-tipping", gsm: 200, images:["/polo/bt2.png","/polo/bt4.png"] },
  { title: "Inside Out Collar T-Shirt", slug:"inside-out-collar-t-shirt", gsm: 230, images:["/polo/mc2.png","/polo/mc6.png"] },
  { title: "Pullover Hoodies", slug:"pullover-hoodies", gsm: 300, images:["/hoodies/hp2.png","/hoodies/hp5.png"] },
  { title: "Zipper Hoodie", slug:"zipper-hoodie", gsm: 300, images:["/hoodies/hm2.png","/hoodies/hm5.png"] },
  { title: "Premium Pullover Hoodie", slug:"premium-pullover-hoodie", gsm: 350, images:["/hoodies/hb2.png","/hoodies/hb1.png"] },
  { title: "Premium Support Hoodie", slug:"premium-support-hoodie", gsm: 350, images:["/hoodies/hdb2.png","/hoodies/hdb6.png"] },
  { title: "Sweatshirt", slug:"sweatshirt", gsm: 350, images:["/hoodies/sbr1.png","/hoodies/sbr4.png"] },
  { title: "Varsity", slug:"varsity-jacket", gsm: 400, images:["/jackets/vb2.png","/jackets/vb6.png"] },
  { title: "Tote Bag", slug:"tote-bag", gsm: 350, images:["/hoodies/bag0.png","/hoodies/bag3.png"] },
  { title: "Caps", slug:"caps", gsm: null, images:["/hoodies/snapBack0.png","/hoodies/snapBack1.png"] },
];

export default function Products() {

  const [filteredProducts, setFilteredProducts] = useState(PRODUCT_CARDS);
  const [selectedProduct, setSelectedProduct] = useState("all");
  const [selectedGsm, setSelectedGsm] = useState("all");

  const applyFilters = (productValue, gsmValue) => {
  let filtered = PRODUCT_CARDS;

  if (productValue !== "all") {
    if (productValue === "tshirt") {
      filtered = filtered.filter(
        (p) => p.slug.includes("round-neck")
      );
    }

    if (productValue === "polo") {
      filtered = filtered.filter(
        (p) => p.slug.includes("collar")
      );
    }

    if (productValue === "hoodie") {
      filtered = filtered.filter(
        (p) => p.slug.includes("hoodie")
      );
    }

    if (productValue === "sweatshirt") {
      filtered = filtered.filter(
        (p) => p.slug === "sweatshirt"
      );
    }

    if (productValue === "varsity") {
      filtered = filtered.filter(
        (p) => p.slug.includes("varsity")
      );
    }

    if (productValue === "tote") {
      filtered = filtered.filter(
        (p) => p.slug.includes("tote")
      );
    }

    if (productValue === "caps") {
      filtered = filtered.filter(
        (p) => p.slug.includes("caps")
      );
    }
  }

  if (gsmValue !== "all") {
    filtered = filtered.filter((p) => p.gsm === Number(gsmValue));
  }

  setFilteredProducts(filtered);
};


  return (
    <>
      <Navbar />

      <main className="bg-white text-[#1a1a1a]">

        <section
          className="relative h-[260px] sm:h-[300px] md:h-[340px] flex items-center"
          style={{
            backgroundImage: "url('/Breadcrumb.png')",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <div className="absolute inset-0 bg-black/35" />
          <div className="relative z-10 max-w-7xl mx-auto px-6">
            <h2 className="text-white text-[clamp(36px,4.5vw,60px)] tracking-wide">
              ALL PRODUCTS
            </h2>
          </div>
        </section>

        <div className="bg-[#e6e6e6] border-b">
          <div className="max-w-7xl mx-auto px-6 py-4 flex flex-wrap items-center gap-4">

            <select
  value={selectedProduct}
  onChange={(e) => {
    const value = e.target.value;
    setSelectedProduct(value);
    applyFilters(value, selectedGsm);
  }}
  className="px-4 py-2 bg-white border text-gray-700 min-w-[220px]"
>
  <option value="all">All</option>
  <option value="tshirt">T-Shirt</option>
  <option value="polo">Polo T-Shirt</option>
  <option value="hoodie">Hoodies</option>
  <option value="sweatshirt">Sweatshirt</option>
  <option value="varsity">Varsity</option>
  <option value="tote">Tote Bag</option>
  <option value="caps">Caps</option>
</select>


            <select
              value={selectedGsm}
              onChange={(e) => {
                const value = e.target.value;
                setSelectedGsm(value);
                applyFilters(selectedProduct, value);
              }}
              className="px-4 py-2 bg-white border text-gray-700 min-w-[180px]"
            >
              <option value="all">Fabric Weight</option>
              <option value="170">170 GSM</option>
              <option value="180">180 GSM</option>
              <option value="200">200 GSM</option>
              <option value="220">220 GSM</option>
              <option value="230">230 GSM</option>
              <option value="240">240 GSM</option>
              <option value="260">260 GSM</option>
              <option value="300">300 GSM</option>
              <option value="350">350 GSM</option>
              <option value="400">400 GSM</option>
            </select>

            <button
              onClick={() => {
                setSelectedProduct("all");
                setSelectedGsm("all");
                setFilteredProducts(PRODUCT_CARDS);
              }}
              className="text-gray-700 font-medium"
            >
              Reset
            </button>

          </div>
        </div>

        <section className="bg-[#efefef] py-10">
  <div className="px-[4vw]">
    <ProductGrid products={filteredProducts} />
  </div>
</section>


      </main>

      <Component_Products />
      <Footer />
    </>
  );
}

/* ================= PRODUCT GRID ================= */
function ProductGrid({ products }) {

  const [visibleCount, setVisibleCount] = useState(() => {
    const saved = sessionStorage.getItem("visibleCount");
    return saved ? parseInt(saved) : 8;
  });

  if (products.length === 0) {
    return (
      <div className="text-center mt-16">
        <p className="text-gray-500 text-lg">
          No products found for selected filters.
        </p>
        <button
          onClick={() => window.location.reload()}
          className="mt-6 px-6 py-2 bg-black text-white hover:bg-gray-800 transition"
        >
          View All Products
        </button>
      </div>
    );
  }

  return (
    <>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-6">
        {products.slice(0, visibleCount).map((item, i) => (
          <ProductCard key={i} item={item} />
        ))}
      </div>

      {visibleCount < products.length && (
        <div className="flex justify-center mt-6">
          <button
            onClick={() => {
              setVisibleCount(products.length);
              sessionStorage.setItem("visibleCount", products.length);
            }}
            className="border px-4 py-1 text-sm bg-white"
          >
            Load More...
          </button>
        </div>
      )}
    </>
  );
}

/* ================= PRODUCT CARD ================= */
function ProductCard({ item }) {

  const [index, setIndex] = useState(0);
  const hoverTimer = useRef(null);
  const navigate = useNavigate();

  const handleEnter = () => {
    hoverTimer.current = setTimeout(() => {
      setIndex((prev) => (prev === 0 ? 1 : 0));
    }, 0);
  };

  const handleLeave = () => {
    clearTimeout(hoverTimer.current);
  };

  return (
    <div
      onClick={() => {

        if (item.title === "Cotton Round Neck T-Shirt")
          navigate("/products/cotton-round-neck-t-shirt");

        if (item.title === "Oversized Round Neck T-Shirt")
          navigate("/products/oversized-round-neck-t-shirt");

        if (item.title === "Dryfit Round Neck T-Shirt")
          navigate("/products/dryfit-round-neck-t-shirt");

        if (item.title === "Micropolyester Collar T-Shirt")
          navigate("/products/micropolyester-collar-t-shirt");

        if (item.title === "Micropolyester Collar T-Shirt with Press Buttons")
          navigate("/products/micropolyester-collar-t-shirt-press-buttons");

        if (item.title === "Cotton Collar T-Shirt")
          navigate("/products/cotton-collar-t-shirt");

        if (item.title === "Cotton Collar T-Shirt with Tipping")
          navigate("/products/cotton-collar-t-shirt-with-tipping");

        if (item.title === "Dryfit Collar T-Shirt")
          navigate("/products/dryfit-collar-t-shirt");

        if (item.title === "Dryfit Collar T-Shirt with Tipping")
          navigate("/products/dryfit-collar-t-shirt-with-tipping");

        if (item.title === "Inside Out Collar T-Shirt")
          navigate("/products/inside-out-collar-t-shirt");

        if (item.title === "Pullover Hoodies")
          navigate("/products/pullover-hoodies");

        if (item.title === "Zipper Hoodie")
          navigate("/products/zipper-hoodie");

        if (item.title === "Premium Pullover Hoodie")
          navigate("/products/premium-pullover-hoodie");

        if (item.title === "Premium Support Hoodie")
          navigate("/products/premium-support-hoodie");

        if (item.title === "Sweatshirt")
          navigate("/products/sweatshirt");

        if (item.title === "Varsity")
          navigate("/products/varsity-jacket");

        if (item.title === "Tote Bag")
          navigate("/products/tote-bag");

        if (item.title === "Caps")
          navigate("/products/caps");

      }}
      onMouseEnter={handleEnter}
      onMouseLeave={handleLeave}
      className="group bg-white border overflow-hidden cursor-pointer transition"
    >
      <div className="w-full h-[380px]">
        <img
          src={item.images[index]}
          alt={item.title}
          className="w-full h-full object-cover"
        />
      </div>

      <div className="px-3 py-2 bg-[#f3f3f3]">
        <p className="text-sm font-medium leading-tight">
          {item.title}
        </p>
      </div>
    </div>
  );
}
